import Vue from "vue/dist/vue.js";
// import Popper from "popper.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/src/jquery.js";
import "bootstrap/dist/js/bootstrap.min.js";

import App from "./ServicekleberApp.vue";

// import router from "./router";
// import store from "./store";
//
// import { CHECK_AUTH } from "./store/actions.type";
// import ApiService from "./common/api.service";
// import DateFilter from "./common/date.filter";
// import ErrorFilter from "./common/error.filter";
//
// Vue.filter("date", DateFilter);
// Vue.filter("error", ErrorFilter);
//
// ApiService.init();
//
// // Ensure we checked auth before each page load.
// router.beforeEach((to, from, next) =>
//   Promise.all([store.dispatch(CHECK_AUTH)]).then(next)
// );
//

Vue.config.productionTip = true;
Vue.config.devtools = false;
Vue.config.debug = false;

new Vue({
  // router,
  // store,
  render: h => h(App)
}).$mount("#app");
window.onload = () => {
  "use strict";

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("./tibtixsw.js", { scope: "./" });
  }
};
